/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import {REPORT_DETAIL_GROUP_REQUEST, REPORT_DETAIL_GROUP_SUCCESS, REPORT_DETAIL_GROUP_FAILURE} from "../../types";

const DetailGoupReportAction = (groupId) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/group-report/${groupId}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            REPORT_DETAIL_GROUP_REQUEST,
            {
                type: REPORT_DETAIL_GROUP_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REPORT_DETAIL_GROUP_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REPORT_DETAIL_GROUP_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REPORT_DETAIL_GROUP_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {DetailGoupReportAction}